import api from '../../apiConfig/apiConfig'
import { Get, Post } from '../base/baseAjax'

//获取工单详情
let getWorkOrderInfo = id => {
  return Get({
    url: api.workorder.workorderinfo + id
  })
}

//获取工单日志
let getWorkorderlog = param => {
  return Get({
    url: api.workorder.selectworkorderlog,
    PathParam: param
  })
}

//获取工单列表
let workorderpage = param => {
  return Post({
    url: api.workorder.workorderpage,
    bodyParam: param
  })
}

//保存工单信息
let saveworkorder = param => {
  return Post({
    url: api.workorder.saveworkorder,
    bodyParam: param
  })
}

//根据客户信息获取服务单信息
let selectservice = param => {
  return Post({
    url: api.workorder.selectservice,
    bodyParam: param
  })
}

//操作工单状态
let operation = param => {
  
  return Post({
    url: api.workorder.operation,
    bodyParam: param
  })
}

//根据服务单信息获取域名
let domainbyservice = param => {
  return Post({
    url: api.workorder.domainbyservice,
    bodyParam: param
  })
}

//添加备注
let addremarks = param => {
  return Post({
    url: api.workorder.addremarks,
    bodyParam: param
  })
}

// 处理状态枚举
let handleStatus = () => {
  return Get({
    url: api.enum.gethandlestatusenum
  })
}

// 问题类型枚举
let problemType = () => {
  return Get({
    // url: api.enum.getproblemtypeenum
    url: api.workorder.problemtype
  })
}

// 工单类型枚举
let workOrderType = () => {
  return Get({
    url: api.workorder.workordertype
  })
}

export default {
  getWorkOrderInfo,
  getWorkorderlog,
  workorderpage,
  saveworkorder,
  selectservice,
  operation,
  domainbyservice,
  addremarks,
  handleStatus,
  problemType,
  workOrderType
}
